import React from "react";
import { Button, Box } from "@mui/material";

const ErrorComponent = ({ onClick }: any) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#F1F1F1"
      marginLeft="-35px"
    >
      <h4
        style={{
          marginTop: "-360px",
          color: "#1976d2",
          fontSize: "60px",
          marginBottom: 0,
        }}
      >
        Ops...
      </h4>
      <p style={{ fontWeight: 700, marginBottom: 40 }}>
        Tivemos dificuldade em recuperar os dados.
      </p>
      <Button
        variant="contained"
        color="primary"
        onClick={onClick}
        sx={{
          textTransform: "none",
          fontSize: "16px",
          padding: "8px 16px",
          width: "150px",
          borderRadius: 0,
          boxShadow: 0,
        }}
      >
        Tentar novamente
      </Button>
    </Box>
  );
};

export default ErrorComponent;
